import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["courtFields"];

  connect() {
    this.toggleCourtFields();
  }

  kindChanged() {
    this.toggleCourtFields();
  }

  toggleCourtFields() {
    const selected = this.element.querySelector(
      'input[name="lawsuit[kind]"]:checked'
    );
    const isOutOfCourt = selected?.value === "out_of_court";
    this.courtFieldsTargets.forEach((el) => {
      el.classList.toggle("hidden", isOutOfCourt);
    });
  }
}
